import { z } from 'zod'
import { fileUpload } from '~/services/api/contracts/fileUpload'
import { StoreMenuItemRequestSchema } from '~/services/api/generated'
import { menuItemFieldsNormalizer } from '~/services/api/contracts/normalizers/menuItemFieldsNormalizer'

interface MenuItemStoreContext {
  readonly menu_id_required: boolean
}

const PHOTO = { mimes: ['jpeg', 'jpg', 'png', 'webp'], maxKb: 5120 } as const

const hasAtMostTwoDecimals = (value: number): boolean =>
  Math.abs(value * 100 - Math.round(value * 100)) < 1e-9

const schema = StoreMenuItemRequestSchema.extend({ photo: fileUpload(PHOTO).optional() }).strict()

export const MenuItemStore = (context: MenuItemStoreContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(menuItemFieldsNormalizer, schema).superRefine((value, issues) => {
    if (context.menu_id_required && (value.menu_id === undefined || value.menu_id === null)) {
      issues.addIssue({
        code: 'custom',
        message: 'The menu id field is required',
        path: ['menu_id']
      })
    }
    if (
      value.price_type === 'group_tray' &&
      (value.serves_count === undefined || value.serves_count === null)
    ) {
      issues.addIssue({
        code: 'custom',
        message: 'The serves count field is required when price type is group_tray',
        path: ['serves_count']
      })
    }
    if (!hasAtMostTwoDecimals(value.default_price)) {
      issues.addIssue({
        code: 'custom',
        message: 'The default price field must have 0-2 decimal places',
        path: ['default_price']
      })
    }
  })
